import React from 'react';
import IntroImage from '../Intro.png';
import styles from '../App.module.less';

const IntroSection = () => {
  return (
    <div className={styles.intro}>
      <img className={styles.image} src={IntroImage} alt="" />
      <div className={`${styles.copy} ${styles.cmeF20}`}>
        <h1 className={styles.cmeF40}>OhioRISE Care Management Entities</h1>
        <p>
          Ohio has 18 regional care partners known as care management entities (CMEs) who manage care coordination for youth enrolled in OhioRISE.
        </p>
        <p>
          Each CME connects OhioRISE members with a care coordinator. Your care coordinator is your guide and advocate. They help:
        </p>
        <ul>
          <li>
            Build a support team that includes schools, doctors, therapists and family. This is known as the Child and Family Team.
          </li>
          <li>Organize meetings to make sure everyone is working together.</li>
          <li>Connect you to services like therapy, respite or crisis response.</li>
          <li>Monitor progress and adjust the care plan as your child grows.</li>
        </ul>

        <h2 className={styles.cmeF30}>
          Are you ready to enroll in OhioRISE?
        </h2>
        <p>Your child may be eligible if they:</p>
        <ul>
          <li>Are under age 21,</li>
          <li>Are determined eligible for Ohio Medicaid,</li>
          <li>Are not enrolled in a MyCare Ohio plan, and</li>
          <li>Have one of the following:
            <ul>
              <li>Certain needs for behavioral healthcare, identified by the Ohio Children's Initiative (OCI) and the Child and Adolescent Needs and Strengths (CANS) assessment, or</li>
              <li>A recent inpatient hospital stay for mental illness or substance use disorder, or</li>
              <li>A recent inpatient stay in a Psychiatric Residential Treatment Facility (PRTF).</li>
            </ul>
          </li>
        </ul>
        <p>
          To enroll in OhioRISE, your child must complete an assessment. Start by reaching out to the CME in your county or zip code and they can perform the assessment.
        </p>
        <p>Search below to find your CME.</p>
        <p className={`${styles.cmeFcP}`}>
          If you or someone you know is struggling with an immediate crisis, help is available. <strong>Call or text 988 or chat at <a href="https://988lifeline.org/" target="_blank" rel="noreferrer" className={`${styles.cmeFcP}`}>988lifeline.org</a>.</strong>
        </p>
      </div>
    </div>
  );
};

export default IntroSection;